const BASE_COLORS = [
  "#5D89DF",
  "#64BDC6",
  "#EECA34",
  "#FE6A35",
  "#B021F3",
  "#F33A9E",
  "#2FB819",
  "#2196F3",
];

/** Return base color by element index, so we can use consistent colors for various analytics components */
export const getBaseColorByIndex = (index: number) =>
  BASE_COLORS[index % BASE_COLORS.length];

const ISO_3166_1_ALPHA_2 = /^[A-Z]{2}$/;
const DISPLAY_NAMES_EN = new Intl.DisplayNames(["en"], { type: "region" });

/** Return English name for ISO 3166-1 alpha-2 code or return input back if invalid */
export const getCountryNameByIsoCode = (isoAlpha2: string): string => {
  const upper = isoAlpha2.toUpperCase();

  if (upper.length !== 2 || !ISO_3166_1_ALPHA_2.test(upper)) {
    return isoAlpha2;
  }

  try {
    const resolved = DISPLAY_NAMES_EN.of(upper);

    if (resolved === undefined) {
      return isoAlpha2;
    }

    return resolved;
  } catch {
    return isoAlpha2;
  }
};

export const normalizeChartValue = (value: number, isMobile: boolean) => {
  if (value <= 0) {
    return value;
  }

  const exponent = isMobile ? 1 / 3 : 1 / 2;

  return value ** exponent;
};
